import { Tabs } from 'antd' // Button
import React from 'react' // , { useState } 
import PadContainer from '../../../components/PadContainer'
// import { handleCapitalize, include } from '../../../context/utils'
// import { useSearchParams } from 'react-router-dom'
import ProductTabs from './productTab'
import ProductColorTab from './productColor'

function ProductsManagementPage() {
  // const [param, setParam] = useSearchParams()
  // const [tab, setTab] = useState(param.get("tab") || "Product")
  // const tabs = [
  //   {
  //     title: "Product",
  //     // action: <ProfileAction />,
  //     component: <ProductTabs />,
  //   },
  //   {
  //     title: "Product Color",
  //     component: <ProductColorTab />,
  //   },
  // ]

  const items = [
    {
      key: '1',
      label: 'Category',
      children: <ProductTabs />,
    },
    {
      key: '2',
      label: 'Product Status',
      children: <ProductColorTab />,
    },
  ];
  // const currentTab = tabs.find(({title}) => tab.includes(title))

  // const handleTab = (id) => {
  //   setTab(id)
  //   setParam({tab:id})
  // }
  return (
    <PadContainer className="space-y-1">
      {/* <div className='w-full justify-between items-center bg-white rounded-lg shadow p-2'> */}
        {/* <div className='bg-[#F2F6FC] rounded-xl p-1'> */}
          {/* {tabs.map(({title}) => (
            <Button onClick={() => handleTab(title)} className={`${include(title, tab)?"bg-light_blue":"!bg-transparent text-secondary"} !shadow-none !px-10`} type="primary" size='large' key={title} id={title}>{handleCapitalize(title)}</Button>
          ))} */}
          {/* <Tabs defaultActiveKey="1" items={items} />
        </div> */}
        {/* {currentTab?.action} */}
      {/* </div> */}
      <div className='w-full bg-white rounded-lg border border-[#E4E7EC]'>
        <Tabs defaultActiveKey="1" type='card' size='large' items={items} />
        {/* {currentTab?.component} */}
      </div>
    </PadContainer>
  )
}

export default ProductsManagementPage